/** @jsx jsx */
import { jsx } from 'theme-ui';
import Link from '../link';

export const ButtonContainer = (props) => (
  <div
    sx={{
      display: 'flex',
      flexDirection: ['column', 'row'],
      justifyContent: ['center', 'space-between'],
      alignItems: 'center',
    }}
    {...props}
  />
);

export const buttonStyles = {
  backgroundColor: 'SecondaryBlue2',
  borderRadius: '0.25rem',
  width: '100%',
  maxWidth: '480px',
  display: 'flex',
  flexFlow: 'column nowrap',
  justifyContent: 'center',
  alignSelf: [null, 'stretch'],
  mt: '1.5rem',
  mb: '1.5rem',
  textDecoration: 'none',
  p: '1.8rem',
  boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
  transition: 'box-shadow .25s ease-out, background-color .25s ease-out',
  '&:hover': {
    backgroundColor: 'SecondaryBlue2Hover',
    boxShadow: '0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 4px 8px 0 rgba(0, 0, 0, 0.12)',
    cursor: 'pointer',
  },
  '&:active': {
    transition: 'box-shadow .125s ease-in, background-color .125s ease-in',
    backgroundColor: 'SecondaryBlue2Active',
    boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
  },
  '&:not(:last-child)': {
    mr: [null, '1.5rem'],
  },
};

export const Button = (props) => (
  <Link
    sx={{
      ...buttonStyles,
    }}
    {...props}
  />
);

export const buttonTextStyles = {
  color: 'white',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  lineHeight: '1.2',
  fontWeight: 700,
  fontSize: '2rem',
  textAlign: 'center',
};

export const ButtonText = (props) => (
  <span
    sx={{
      ...buttonTextStyles,
    }}
    {...props}
  />
);
